import React from 'react';
import { Box, Text } from '@chakra-ui/react';

const Calendario = () => {
  return (
    <Box>
      <Text fontWeight="semibold" textStyle="4xl">Calendario</Text>
      <Text>Bienvenido a tus Calendario</Text>

      <Text fontWeight="thin">100</Text>
      <Text fontWeight="extralight">200</Text>
      <Text fontWeight="light">300</Text>
      <Text fontWeight="normal">400</Text>
      <Text fontWeight="medium">500</Text>
      <Text fontWeight="semibold">600</Text>
      <Text fontWeight="bold">700</Text>
      <Text fontWeight="extrabold">800</Text>
      <Text fontWeight="900">900</Text>

      <Text fontFamily="body" fontWeight={500}>Montserrat 500</Text>
      <Text fontFamily="body" fontWeight={600}>Montserrat 600</Text>
      <Text fontFamily="body" fontWeight={800}>Montserrat 800</Text>
      <Text fontFamily="heading" fontWeight={900}>Outfit 900</Text>


    </Box>
  );
};

export default Calendario;
